import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicePageShell from '../../components/ServicePageShell';
import AtoudaAkademitAtidimStatic from './AtoudaAkademitAtidimStatic';

const AtoudaAkademitAtidim = () => (
  <ServicePageShell
    strapiApiId="service-atouda-akademit-atidim"
    defaultTitle="Atouda Akademit et Atidim"
    StaticFallback={AtoudaAkademitAtidimStatic}
  />
);

export default AtoudaAkademitAtidim;
